import { Chain, Order } from '@shared/data-access/interfaces';
import { Component, OnInit } from '@angular/core';
import { MyAccountAnalyticsService, Store, TrackOrdersService } from '@shared/data-access/services';
import {
	PlacementID,
	PriceRerankLevel,
	ProductRecommendationsPageType
} from '@product-recommendations/data-access';

import { ActivatedRoute } from '@angular/router';
import { UtilityService } from '@shared/utils/services';
import { first } from 'rxjs/operators';

@Component({
	selector: 'my-account-templates-order-detail',
	templateUrl: './order-detail.component.html',
	styleUrls: ['./order-detail.component.scss']
})
export class OrderDetailComponent implements OnInit {
	orderDetail: Order;
	pageType = ProductRecommendationsPageType;
	priceRerankLevel = PriceRerankLevel;
	placementID = PlacementID;
	showDSRecommendationsOD = false;
	resendEmailModalOpen = false;
	public eCodeList: string[] = [];

	constructor(
		private trackOrdersService: TrackOrdersService,
		private route: ActivatedRoute,
		private analyticsService: MyAccountAnalyticsService,
		private chain: Chain,
		private utilityService: UtilityService,
		private store: Store
	) {	}

	ngOnInit(): void {
		this.trackOrdersService.getOrder(this.route.snapshot.params['orderNumber'])
			.subscribe((order) => {
				this.orderDetail = order;
				this.eCodeList = this.orderDetail.items.map(x => x.ecode);
				this.analyticsService.setOrderId(order.orderNumber.toString());
			});
		this.store.select('ENVIRONMENT_KILLSWITCH_VALUES')
			.pipe(first())
			.subscribe((killSwitch: any) => {
				this.showDSRecommendationsOD = this.utilityService.checkKillSwitch('showDSRecommendationsOD', killSwitch, this.chain.chainIdentifierAbbr);
			});
	}
}
